/** Formattazione di orari e date per l'interfaccia (fuso del dispositivo). */

export function fmtTime(ms: number): string {
  return new Date(ms).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}

function sameDay(x: Date, y: Date): boolean {
  return (
    x.getFullYear() === y.getFullYear() &&
    x.getMonth() === y.getMonth() &&
    x.getDate() === y.getDate()
  );
}

/** «oggi 14:30», «domani 08:00», «gio 4 set, 18:15». */
export function fmtWhen(ms: number, now = Date.now()): string {
  const d = new Date(ms);
  const n = new Date(now);
  const tomorrow = new Date(n);
  tomorrow.setDate(n.getDate() + 1);
  if (sameDay(d, n)) return `oggi ${fmtTime(ms)}`;
  if (sameDay(d, tomorrow)) return `domani ${fmtTime(ms)}`;
  const day = d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
  return `${day}, ${fmtTime(ms)}`;
}

/** Valore per <input type="datetime-local"> nel fuso locale. */
export function toLocalInputValue(ms: number): string {
  const d = new Date(ms);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
